import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon, PlayIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { candidate } from '../../data/site';
type HeroProps = {
  onWatch: () => void;
};
export function Hero({
  onWatch
}: HeroProps) {
  const navigate = useNavigate();
  return <section className="relative overflow-hidden bg-ink" aria-labelledby="hero-heading" data-id="element-164" data-mp="epdkrlfc0lou">
      <div aria-hidden className="absolute inset-y-0 right-0 hidden w-1/2 bg-ink-700 lg:block" data-id="element-165" data-mp="apl8axmthve7" />
      <div className="relative mx-auto grid max-w-content items-center gap-10 px-4 pb-16 pt-14 sm:px-6 lg:grid-cols-12 lg:gap-14 lg:px-10 lg:pb-24 lg:pt-20" data-id="element-166" data-mp="5nvwhfrrtdp2">
        <div className="lg:col-span-6" data-id="element-167" data-mp="3rx6vdc31xvuk">
          <p className="flex items-center gap-3 font-sans text-[13px] font-semibold uppercase tracking-[0.16em] text-gold-400" data-id="element-168" data-mp="3ry89jpfd6ygi">
            <span aria-hidden className="h-px w-8 bg-gold-500" data-id="element-169" data-mp="1v20zioos1fko" />
            {candidate.eyebrow}
          </p>

          <h1 id="hero-heading" className="mt-6 max-w-[15ch] font-display text-[40px] font-semibold leading-[1.04] tracking-[-0.025em] text-white sm:text-[56px] lg:text-[64px]" data-id="element-170" data-mp="1mwcc4ch4vl0s">
            A Nigeria That Works.{' '}
            <span className="text-gold-400" data-id="element-171" data-mp="1czprnospyvza">For Everyone.</span>
          </h1>

          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-white/70 sm:text-[19px]" data-id="element-172" data-mp="1hyat1rjpjlpb">
            {candidate.supporting}
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-173" data-mp="25owydb2burvm">
            <Button size="lg" className="w-full sm:w-auto" onClick={() => navigate('/vision')} data-id="element-174" data-mp="2al5bkiwysb05">
              Explore the Vision
              <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-175" data-mp="20w3xiy9zc3ot" />
            </Button>
            <Button size="lg" variant="secondary" onDark className="w-full sm:w-auto" onClick={() => navigate('/join')} data-id="element-176" data-mp="20tr67uic0gz3">
              Join the Movement
            </Button>
          </div>

          <button type="button" onClick={onWatch} className="group mt-8 flex items-center gap-3 text-left" data-id="element-177" data-mp="337luj10i4wrx">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 ease-emphasis group-hover:border-gold-400 group-hover:text-gold-400" data-id="element-178" data-mp="2u773rm4rqph1">
              <PlayIcon aria-hidden className="ml-0.5 h-4 w-4 fill-current" data-id="element-179" data-mp="2kaasx9redr9b" />
            </span>
            <span data-id="element-180" data-mp="2fi0zvkuzkb2t">
              <span className="block text-[15px] font-semibold text-white" data-id="element-181" data-mp="2fhhraur86z1g">
                Watch the campaign message
              </span>
              <span className="block text-[13px] text-white/50" data-id="element-182" data-mp="26ie3xel0zxh5">3 min · captions available</span>
            </span>
          </button>
        </div>

        <div className="lg:col-span-6" data-id="element-183" data-mp="21ii4lsn9wu7x">
          <div className="relative mx-auto max-w-[520px] lg:max-w-none" data-id="element-184" data-mp="1wjyhvq0uveei">
            <div className="overflow-hidden rounded-media border border-white/10 bg-ink-600" data-id="element-185" data-mp="1wm1eiswik5s7">
              <img src={candidate.portraitPrimary} alt={`${candidate.name}, presidential candidate, at his desk`} className="h-full w-full object-cover" width={1084} height={1447} data-id="element-186" data-mp="c1nsvgsoiu4w" />
            </div>
            <div className="absolute -bottom-5 left-4 right-4 rounded-card border border-sand-200 bg-sand-50 px-5 py-4 shadow-lift sm:left-6 sm:right-auto sm:max-w-[320px]" data-id="element-187" data-mp="q0vyarffqyhj">
              <p className="font-display text-[15px] leading-snug text-ink" data-id="element-188" data-mp="3ugydw9qj0dgc">
                “I am not asking Nigerians to hope. I am asking them to hold me to a published
                standard.”
              </p>
              <p className="mt-2 text-[12px] font-semibold uppercase tracking-[0.1em] text-green-700" data-id="element-189" data-mp="74dx7jep5m8m">
                {candidate.name}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}